import React, { useContext } from 'react';
import LocationInformation from './LocationInformation';
import LocationCribSheet from './LocationCribSheet';
import { IDetailLoctaion } from '../../../types';
import { MyContext } from '../../../context';

const LocationInfo: React.FC<IDetailLoctaion> = ({ locationData, setSubTab, subTab, cribsEnteries, deleteCrib, onAddCrib, updateCrib, updateLoc, fetchMoreData, nextUrl, role, canViewLocation, addLocTags, addProd, vaultType, onEditTag }) => {

    const { userData } = useContext(MyContext);

    const isLocationOwner = userData?.id == locationData?.created_by?.id

    return (
        <div className="la-wrap">

            {/*Sub tab bar */}
            <div className="la-subtabs-bar">
                <div className="la-subtabs">
                    <button
                        className={`la-subtab${subTab === 'info' ? ' la-subtab--active' : ''}`}
                        onClick={() => setSubTab?.('info')}
                    >
                        Location Information
                    </button>
                    <button
                        className={`la-subtab${subTab === 'crib' ? ' la-subtab--active' : ''}`}
                        onClick={() => setSubTab?.('crib')}
                    >
                        Crib Sheet
                    </button>
                </div>

                {role != 'V' &&
                    <div className="la-subtabs-action">
                        {subTab === 'info' ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                {(isLocationOwner && vaultType == 'myvault') &&
                                    <>
                                        <button type='button' onClick={addLocTags} className="la-btn-action">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                                                <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
                                            </svg>
                                            Add Tags
                                        </button>
                                        <button type='button' onClick={addProd} className="la-btn-action">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                                                <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
                                            </svg>
                                            Add Production
                                        </button>
                                    </>
                                }
                                <button type='button' onClick={updateLoc} className="la-btn-action">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                                        <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
                                    </svg>
                                    Update Information
                                </button>
                            </div>
                        ) : (
                            <button type='button' onClick={onAddCrib} className="la-btn-action">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                                    <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
                                </svg>
                                Add Crib Sheet
                            </button>
                        )}
                    </div>
                }
            </div>

            {/*Sub tab content*/}
            {subTab === 'info' &&
                <LocationInformation
                    locationData={locationData}
                    canViewLocation={canViewLocation}
                    onEditTag={onEditTag}
                />
            }
            {subTab === 'crib' &&
                <LocationCribSheet
                    locationData={locationData}
                    updateCrib={updateCrib}
                    deleteCrib={deleteCrib}
                    cribsEnteries={cribsEnteries}
                    fetchMoreData={fetchMoreData}
                    nextUrl={nextUrl}
                    canViewLocation={canViewLocation}
                    role={role}
                />
            }
        </div>
    );
};

export default LocationInfo;